













































































































































import Vue from 'vue';
import * as Enums from '@/enums.ts';
import * as Util from '@/util.ts';
import * as c from '@/constants.ts';
import firebase from 'firebase/app';
import { eValidationRules, isFormValid } from '@/validation.ts';
import { CombinedVueInstance } from 'vue/types/vue';
import VueGoogleAutocomplete from 'vue-google-autocomplete';

const EMPTY_DELIVERY_ADDRESS = {
  formattedAddress: '',
  addressLine2: null,
  additionalDetails: '',
  latitude: null,
  longitude: null,
  googlePlaceId: '',
  utcOffset: '',
  address: {
    administrativeAreaLevel1: '',
    administrativeAreaLevel2: '',
    country: '',
    locality: '',
    postalCode: '',
    route: '',
    streetNumber: '',
  } as GoogleAddress,
} as DeliveryAddress;

export default Vue.extend({
  components: { VueGoogleAutocomplete },
  props: {
    isForPaymentForm: {
      type: Boolean,
      default: false,
    },
    onFormValid: {
      type: Function,
      default: (): void => undefined,
    },
    onFormInvalid: {
      type: Function,
      default: (): void => undefined,
    },
  },
  mounted() {
    this.onPageLoad();
  },
  data() {
    return {
      isDirty: false,
      saveAsPrimaryAddress: true,
      showDeliveryAddressForm: !this.$store.state.currentDeliveryAddress,
      formIsValidForCurrentContext: false,
      // loadedGooglePlacesApi: false,
      gotAPlaceFromGoogle: false,
      currentDeliveryAddress: { ...EMPTY_DELIVERY_ADDRESS },
      settings: {
        contactEmail: '',
        contactNumber: -1,
        referenceName: '',
        includeTaxWithPrices: false,
        showImagesAutomatically: true,
      } as UserSettings,
    };
  },
  watch: {
    formIsValidForCurrentContext(newValue) {
      if (newValue) {
        this.$props.onFormValid();
      } else {
        this.$props.onFormInvalid();
      }
    },
    currentClientUser() {
      this.onPageLoad();
    },
    $route(to, from) {
      if (to.fullPath.includes('/settings') || to.fullPath.includes('/order')) {
        this.onPageLoad();
      }
    },
  },
  computed: {
    deliveryAddressFromState(): DeliveryAddress {
      return this.$store.state.currentDeliveryAddress;
    },
    currentClientUser(): ClientUser {
      return this.$store.state.currentClientUser;
    },
    isDeliveryMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.delivery;
    },
    isTakeoutMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.takeout;
    },
    isTablesideMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.tableside;
    },
    showReferenceName(): boolean {
      return !this.$props.isForPaymentForm || !this.$store.state.referenceName;
    },
    showContactEmail(): boolean {
      return (!this.isTablesideMode || this.contactTracingEnabled) && (!this.$props.isForPaymentForm || !this.$store.state.contactEmail);
    },
    showContactNumber(): boolean {
      return (!this.isTablesideMode || this.contactTracingEnabled) && (!this.$props.isForPaymentForm || !this.$store.state.contactNumber);
    },
    showContactLabel(): boolean {
      return !this.$props.isForPaymentForm || this.showReferenceName || this.showContactEmail || this.showContactNumber;
    },
    contactTracingEnabled(): boolean {
      return this.isTablesideMode;
    },
  },
  methods: {
    makeDirty() {
      if (!this.$props.isForPaymentForm) {
        Util.showNotice('Click the save button at the bottom of the page to save your changes.');
      }
      this.$data.formIsValidForCurrentContext = false;
      this.$data.isDirty = true;
    },
    makeClean() {
      this.$data.formIsValidForCurrentContext = this.isFormValidCheck(true);
      this.$data.isDirty = !this.isFormValidCheck(true);
    },
    onGoogleAutocompleteError(error: any) {
      Util.showError(error?.message);
    },
    getAddressData(addressData: any, place: any) {
      this.$data.gotAPlaceFromGoogle = true;
      this.$data.currentDeliveryAddress.formattedAddress = place.formatted_address || '';
      this.$data.currentDeliveryAddress.address.administrativeAreaLevel1 = addressData.administrative_area_level_1 || '';
      this.$data.currentDeliveryAddress.address.administrativeAreaLevel2 = addressData.administrative_area_level_2 || '';
      this.$data.currentDeliveryAddress.address.country = addressData.country || '';
      this.$data.currentDeliveryAddress.address.locality = addressData.locality || '';
      this.$data.currentDeliveryAddress.address.postalCode = addressData.postal_code || '';
      this.$data.currentDeliveryAddress.address.route = addressData.route || '';
      this.$data.currentDeliveryAddress.address.streetNumber = addressData.street_number || '';
      this.$data.currentDeliveryAddress.latitude = addressData.latitude || null;
      this.$data.currentDeliveryAddress.longitude = addressData.longitude || null;
      this.$data.currentDeliveryAddress.googlePlaceId = place.place_id || '';
      this.$data.currentDeliveryAddress.utcOffset = place.utc_offset_minutes || '';
      this.makeDirty();
    },
    onPageLoad() {
      setTimeout(() => {
        if (this.$refs.addressInput) {
          (this.$refs.addressInput as any).$el.setAttribute('autocomplete', 'disabled');
        }
      }, 1000);
      this.updateDeliveryAddressFromState();
      this.$data.settings.contactEmail = this.$store.state.contactEmail;
      this.$data.settings.contactNumber = this.$store.state.contactNumber;
      this.$data.settings.referenceName = this.$store.state.referenceName;
      this.$data.settings.includeTaxWithPrices = this.$store.state.includeTaxWithPrices;
      this.$data.settings.showImagesAutomatically = this.$store.state.showImagesAutomatically;

      this.$data.formIsValidForCurrentContext = this.isFormValidCheck(true);
    },
    updateDeliveryAddressFromState() {
      const deliveryAddressInState = this.deliveryAddressFromState;
      if (deliveryAddressInState) {
        this.$data.showDeliveryAddressForm = false;
        this.$data.gotAPlaceFromGoogle = true;
        this.$data.currentDeliveryAddress.formattedAddress = deliveryAddressInState.formattedAddress;
        this.$data.currentDeliveryAddress.address.administrativeAreaLevel1 = deliveryAddressInState.address.administrativeAreaLevel1;
        this.$data.currentDeliveryAddress.address.administrativeAreaLevel2 = deliveryAddressInState.address.administrativeAreaLevel2;
        this.$data.currentDeliveryAddress.address.country = deliveryAddressInState.address.country;
        this.$data.currentDeliveryAddress.address.locality = deliveryAddressInState.address.locality;
        this.$data.currentDeliveryAddress.address.postalCode = deliveryAddressInState.address.postalCode;
        this.$data.currentDeliveryAddress.address.route = deliveryAddressInState.address.route;
        this.$data.currentDeliveryAddress.address.streetNumber = deliveryAddressInState.address.streetNumber;
        this.$data.currentDeliveryAddress.latitude = deliveryAddressInState.latitude;
        this.$data.currentDeliveryAddress.longitude = deliveryAddressInState.longitude;
        this.$data.currentDeliveryAddress.googlePlaceId = deliveryAddressInState.googlePlaceId;
        this.$data.currentDeliveryAddress.utcOffset = deliveryAddressInState.utcOffset;
        this.$data.currentDeliveryAddress.addressLine2 = deliveryAddressInState.addressLine2;
        this.$data.currentDeliveryAddress.additionalDetails = deliveryAddressInState.additionalDetails;
        const addressInput: any = this.$refs.addressInput;
        if (addressInput) {
          (addressInput.$el as HTMLInputElement).value = this.$data.currentDeliveryAddress.formattedAddress;
        }
      }
    },
    onChangeDeliveryAddress() {
      this.$data.currentDeliveryAddress = { ...EMPTY_DELIVERY_ADDRESS };
      this.$data.gotAPlaceFromGoogle = false;
      this.$data.showDeliveryAddressForm = true;
      const addressInput: any = this.$refs.addressInput;
      if (addressInput) {
        (addressInput.$el as HTMLInputElement).value = '';
      }
      this.makeDirty();
    },
    onCancelChangeDeliveryAddress() {
      this.updateDeliveryAddressFromState();
      this.makeClean();
    },
    isFormValidCheck(quietValidation: boolean = false): boolean {
      if (this.isTakeoutMode) {
        return isFormValid(
          this,
          this.$data.settings,
          [
            [eValidationRules.requiredGenericStringRules, ['referenceName']],
            [eValidationRules.requiredPhoneRules, ['contactNumber']],
            [eValidationRules.requiredEmailRules, ['contactEmail']],
          ],
          quietValidation
        );
      } else if (this.isDeliveryMode) {
        if (!this.$data.gotAPlaceFromGoogle) {
          if (!quietValidation) {
            Util.showError(Util.t?.invalidGooglePlace);
          }
          return false;
        }
        if (this.$data.currentDeliveryAddress.formattedAddress === '') {
          // Sanity check on a critical address field to make sure we aren't accidentally saving an empty state.
          if (!quietValidation) {
            Util.showError('Unexpected error. Address field empty.');
          }
          return false;
        }
        const areManualEntryDeliveryAddressFieldsValid = isFormValid(this, this.$data.currentDeliveryAddress, [[eValidationRules.genericStringRules, ['addressLine2', 'additionalDetails']]], quietValidation);
        if (!areManualEntryDeliveryAddressFieldsValid) {
          if (!quietValidation) {
            Util.showError(Util.t?.invalidDeliveryAddress);
          }
          return false;
        }
        return isFormValid(
          this,
          this.$data.settings,
          [
            [eValidationRules.requiredGenericStringRules, ['referenceName']],
            [eValidationRules.requiredPhoneRules, ['contactNumber']],
            [eValidationRules.requiredEmailRules, ['contactEmail']],
          ],
          quietValidation
        );
      } else {
        if (this.contactTracingEnabled) {
          return isFormValid(
            this,
            this.$data.settings,
            [
              [eValidationRules.requiredGenericStringRules, ['referenceName']],
              [eValidationRules.requiredPhoneRules, ['contactNumber']],
              [eValidationRules.requiredEmailRules, ['contactEmail']],
            ],
            quietValidation
          );
        } else {
          return isFormValid(this, this.$data.settings, [[eValidationRules.requiredGenericStringRules, ['referenceName']]], quietValidation);
        }
        return true;
      }
    },
    save() {
      this.$data.formIsValidForCurrentContext = this.isFormValidCheck();
      if (!this.$data.formIsValidForCurrentContext) {
        return;
      }

      if (this.$store.state.currentClientUser) {
        const userSettingsUpdate: UserSettings = {
          referenceName: this.$data.settings.referenceName,
          includeTaxWithPrices: this.$data.settings.includeTaxWithPrices,
          showImagesAutomatically: this.$data.settings.showImagesAutomatically,
          contactEmail: this.$data.settings.contactEmail,
          contactNumber: this.$data.settings.contactNumber,
        };

        const update: ClientUserUpdate = {
          settings: userSettingsUpdate,
        };

        // Only save the delivery address if this is delivery mode and we want to save it as the primary address. Otherwise we want to leave it as null in the database.
        if (this.isDeliveryMode && this.$data.saveAsPrimaryAddress) {
          update.deliveryAddress = this.$data.currentDeliveryAddress;
        } else {
          this.$store.commit('setCurrentDeliveryAddress', this.$data.currentDeliveryAddress);
          this.$data.showDeliveryAddressForm = !this.deliveryAddressFromState;
        }

        Util.currFirestore
          .collection('clientUsers')
          .doc(this.$store.state.userId)
          .update(update)
          .then(() => {
            this.$store.commit('setCurrentClientUser', {
              ...this.$store.state.currentClientUser,
              ...update,
            });
            Vue.nextTick(() => {
              this.$data.showDeliveryAddressForm = !this.deliveryAddressFromState;
            });
            Util.showSuccess(Util.t?.infoUpdatedSuccessfully);
          })
          .catch((error: any) => {
            Util.showError('Could not save user settings. ' + error?.message);
          });
      } else {
        // If we have a current client user we just have to update that since the setter will do the following for us. Otherwise we have to call the setter for each of these state variables explicitly.
        this.$store.commit('setCurrentDeliveryAddress', this.$data.currentDeliveryAddress);
        this.$store.commit('setContactEmail', this.$data.settings.contactEmail);
        this.$store.commit('setContactNumber', this.$data.settings.contactNumber);
        this.$store.commit('setReferenceName', this.$data.settings.referenceName);
        this.$store.commit('setIncludeTaxWithPrices', this.$data.settings.includeTaxWithPrices);
        this.$store.commit('setShowImagesAutomatically', this.$data.settings.showImagesAutomatically);
        this.$data.showDeliveryAddressForm = !this.deliveryAddressFromState;
      }
      this.$data.isDirty = false;
    },
  },
});
